var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.563,
    height: 65.707,
    viewBox: "0 0 98.563 65.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video_call-24px",
    d: "M79.66,30.64V11.476A5.492,5.492,0,0,0,74.184,6H8.476A5.492,5.492,0,0,0,3,11.476V66.232a5.492,5.492,0,0,0,5.476,5.476H74.184a5.492,5.492,0,0,0,5.476-5.476V47.067L92.2,59.606a5.492,5.492,0,0,0,9.363-3.888V21.934A5.492,5.492,0,0,0,92.2,18.046Zm-21.9,13.689H46.806V55.28a5.476,5.476,0,0,1-10.951,0V44.329H24.9a5.476,5.476,0,1,1,0-10.951H35.854V22.427a5.476,5.476,0,0,1,10.951,0V33.378H57.757a5.476,5.476,0,1,1,0,10.951Z",
    transform: "translate(-3 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectVideo);
export default __webpack_public_path__ + "static/media/select-video.f73f3e59.svg";
export { ForwardRef as ReactComponent };